module.exports = __webpack_public_path__ + "img/22_31.a6fa71c8.png";